import React from 'react'
import Header from "../components/Layout/Header"
import Sidebar from '../components/Layout/Sidebar';
import Footer from '../components/Layout/Footer';
import ShippingInformation from '../components/Admin/ShippingInformation';

const ShippingInformationPage = () => {
  
  return (
    <div>
        <Header />
        <Sidebar />
        <div>
        <ShippingInformation/>
        </div>
        <Footer />
    </div>
  )
}

export default ShippingInformationPage;